var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgP1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 157,
    viewBox: "0 0 335 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_19",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 157
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 157,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_19)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.333,
    y: 31.129,
    width: 319,
    height: 129,
    transform: "rotate(164 476.333 31.129)",
    fill: "#6372A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.333,
    y: 119.129,
    width: 327,
    height: 155,
    transform: "rotate(-164 171.333 119.129)",
    fill: "#89ABDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.333,
    y: 76.129,
    width: 274,
    height: 100,
    transform: "rotate(-164 146.333 76.129)",
    fill: "#61A9BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.333,
    y: -26.871,
    width: 278,
    height: 86,
    transform: "rotate(158 220.333 -26.871)",
    fill: "#A2D9D2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgP1);
export default __webpack_public_path__ + "static/media/Bg_P1.2085debc1c81720f9ff734ea68d7a86a.svg";
export { ForwardRef as ReactComponent };